/*global AmCharts, App */

Components.Energy.Manager.Power = function(container, loadDataLink, mediumUnit, typeData, reservation) {
    /* private */
    var _chart;
    var from = 0, to = 0;
    var autoLoad = true;
    var zoomOut = function() {
        try {
            _chart.zoom(new Date((from - 30) * 1000), new Date((to-30)*1000));
        } catch (e) {
        }
    };
    var prepareDataForChart = function(rawData, rawDataBefore, childrenData) {
        var chartData = [];
        var powerSum = 0, powerSumBefore = 0;
        var last = 0;
        var stepReservation = reservation / 15, sumReservation = stepReservation;
        chartData.push({reservation: 0, date: new Date((from-60) * 1000)});
        var sum = 0, count = 0, sumBefore = 0, countBefore = 0;
        for (var index in rawDataBefore) {
            var row = rawData[index];
            var rowBefore = rawDataBefore[index];
            if (row.powerConsumptionActive) {
                sum += (Math.round(row.powerConsumptionActive * 100) / 100) * 4;
                count++;
                last = row.powerConsumptionActive*60;
            }
            if (rowBefore.powerConsumptionActive) {
                sumBefore += (Math.round(rowBefore.powerConsumptionActive * 100) / 100) * 4;
                countBefore++;
            }
        }
        var predictionStep = sum/count, predictionSum = 0, predictionStepBefore = sumBefore/countBefore, predictionSumBefore = 0;
        for (var index in rawData) {
            var row = rawData[index];
            var rowBefore = rawDataBefore[index];
            var record = {};
            if (row.powerConsumptionActive) {
                record.powerConsumptionActive = powerSum = ((Math.round(row.powerConsumptionActive * 100) / 100) * 4) + powerSum;
                predictionSum = powerSum;
                predictionSumBefore = powerSum;
            } else {
                record.prediction = predictionSum = predictionSum + predictionStep;
                record.predictionBefore = predictionSumBefore = predictionSumBefore + predictionStepBefore;
            }

            if (rowBefore.powerConsumptionActive) {
                record.before = powerSumBefore = ((Math.round(rowBefore.powerConsumptionActive * 100) / 100) * 4) + powerSumBefore;
            }

            record.reservation = sumReservation;
            sumReservation += stepReservation;
            record.date = new Date(row.timestamp * 1000);
            chartData.push(record);
        }

        if (chartData.length === 0) {
            _chart.clear();
        } else {
            _chart.dataSets[0].dataProvider = chartData;
            _chart.validateData();
        }

        let percent = reservation / 100;

        if (!isNaN(predictionSum)) {
            let per = predictionSum / percent;
            if(per <= 80.0) {
                $("#prediction").html(unit(predictionSum, "W", 2)).removeClass("btn-success btn-warning btn-danger").addClass("btn-success");
            } else if (per > 80.0 && per <= 95.0) {
                $("#prediction").html(unit(predictionSum, "W", 2)).removeClass("btn-success btn-warning btn-danger").addClass("btn-warning");
            } else {
                $("#prediction").html(unit(predictionSum, "W", 2)).removeClass("btn-success btn-warning btn-danger").addClass("btn-danger");
            }
        } else {
            let per = predictionSumBefore / percent;
            if(per <= 80.0) {
                $("#prediction").html(unit(predictionSumBefore, "W", 2)).removeClass("btn-success btn-warning btn-danger").addClass("btn-success");
            } else if (per > 80.0 && per <= 95.0) {
                $("#prediction").html(unit(predictionSumBefore, "W", 2)).removeClass("btn-success btn-warning btn-danger").addClass("btn-warning");
            } else {
                $("#prediction").html(unit(predictionSumBefore, "W", 2)).removeClass("btn-success btn-warning btn-danger").addClass("btn-danger");
            }
        }

        $("#aktual").html(unit(last, "W", 2));

        for (var child in childrenData) {
            $("#childBg-" + child).attr("style", "width: " + childrenData[child]["per"].toFixed(2) + "%;");
            $("#child-" + child).html(childrenData[child]["sum"]);
            $("#per-" + child).html(childrenData[child]["per"].toFixed(1) + "%");
        }

    };
    var unit = function(value, unit, decimals = 0) {
        if(value === 0) return value.toFixed(decimals)+" "+unit;
        let refValue = value;
        if (refValue < 0) {
            refValue = Math.abs(refValue);
        }
        if (refValue >= Math.pow(10, 9)) return (value/Math.pow(10, 9)).toFixed(decimals) + " G"+unit;
        if (refValue >= Math.pow(10, 6)) return (value/Math.pow(10, 6)).toFixed(decimals) + " M"+unit;
        if (refValue >= Math.pow(10, 3)) return (value/Math.pow(10, 3)).toFixed(decimals) + " k"+unit;
        if (refValue <= Math.pow(10, -6)) return (value*Math.pow(10, -6)).toFixed(decimals) + " µ"+unit;
        if (refValue <= Math.pow(10, -3)) return (value*Math.pow(10, -3)).toFixed(decimals) + " m"+unit;
        return value.toFixed(decimals)+" "+unit;
    }

    var loadData = function() {
        App.Ui.widgetBlock($(_chart.containerDiv));
        $.ajax({
            dataType: "json",
            url: loadDataLink,
            complete: function() {
                App.Ui.widgetBlock($(_chart.containerDiv), "stop");
            },
            success: function(result) {
                if (result === null || result.length === 0) {
                    App.Ui.flashMessage(App.Ui.messages.unavailableData, "info");
                } else {
                    _chart.categoryAxesSettings.minPeriod = "1mm";
                    from = result.from;
                    to = result.to;
                    prepareDataForChart(result.records, result.recordsBefore, result.childrenData);
                }
                if(autoLoad) setTimeout(loadData, 60000);
            },
            error: function() {
                App.Ui.flashMessage(App.Ui.messages.unavailableData, "info");
            }
        });

    };
    var createChart = function() {
        _chart = new AmCharts.AmStockChart();
        _chart.height = 380;
        _chart.colors = [App.Ui.getColors()[3]];
        _chart.pathToImages = "/dist/amcharts/images/";
        _chart.export = App.Charts.export;
        _chart.dataSets = [
            {
                categoryField: "date",
                fieldMappings: [
                    {
                        fromField: "powerConsumptionActive",
                        toField: "powerConsumptionActive"
                    },
                    {
                        fromField: "reservation",
                        toField: "reservation"
                    },
                    {
                        fromField: "prediction",
                        toField: "prediction"
                    },
                    {
                        fromField: "predictionBefore",
                        toField: "predictionBefore"
                    }
                ]
            }
        ];

        var stockPanel = new AmCharts.StockPanel();
        stockPanel.autoMarginOffset = 50;
        stockPanel.recalculateToPercents = "never";
        stockPanel.usePrefixes = true;
        stockPanel.colors = _chart.colors;
        _chart.addPanel(stockPanel);

        var graphA = new AmCharts.StockGraph();
        graphA.id = "sg1";
        graphA.valueField = typeData;
        graphA.fillColors = _chart.colors[0];
        graphA.lineColor = _chart.colors[0];
        graphA.type = "column";
        graphA.fillAlphas = 0.9;
        graphA.columnWidth = 0.75;
        graphA.clustered = false;
        graphA.balloonText = "Dosažený Výkon: <b>[[value]]</b>W";
        graphA.useDataSetColors = false;

        var graphB = new AmCharts.ValueAxis();
        graphB.id = "sg2";
        graphB.valueField = "reservation";
        graphB.lineColor = "#ff0000";
        graphB.fillAlphas = 0.2;
        graphB.balloonText = "Maximální rezervovaná kapacita: <b>[[value]]</b>W";
        graphB.useDataSetColors = false;
        graphB.fillToGraph = "toGraph";
        graphB.negativeBase = 180000000;
        graphB.negativeLineColor = "crimson";


        var graphC =  new AmCharts.StockGraph();
        graphC.id = "sg3";
        graphC.valueField = "prediction";
        graphC.lineColor = "#7097c0";
        graphC.fillColor = "#7097c0";
        graphC.type = "column";
        graphC.fillAlphas = 0.5;
        graphC.lineAlphas = 0.3;
        graphC.columnWidth = 0.6;
        graphC.clustered = false;
        graphC.useDataSetColors = false;
        graphC.balloonText = "Predikovaný Výkon: <b>[[value]]</b>W";

        var graphD = new AmCharts.StockGraph();
        graphD.id = "sg4";
        graphD.valueField = "predictionBefore";
        graphD.fillColors = "#c3c3c3";
        graphD.lineColor = "#c3c3c3";
        graphD.type = "column";
        graphD.fillAlphas = 0.3;
        graphD.lineAlphas = 0.3;
        graphD.columnWidth = 0.75;
        graphD.clustered = false;
        graphD.useDataSetColors = false;
        graphD.balloonText = "Predikovaný Výkon z předešlých 15min: <b>[[value]]</b>W";

        stockPanel.addStockGraph(graphA);
        stockPanel.addStockGraph(graphB);
        stockPanel.addStockGraph(graphC);
        stockPanel.addStockGraph(graphD);

        var panelsSettings = new AmCharts.PanelsSettings();
        panelsSettings.marginLeft = 80;
        _chart.panelsSettings = panelsSettings;

        var scrollbarSettings = new AmCharts.ChartScrollbarSettings();
        scrollbarSettings.graph = "sg1";
        scrollbarSettings.graphType = "step";
        scrollbarSettings.updateOnReleaseOnly = false;
        _chart.chartScrollbarSettings = scrollbarSettings;

        var cursorSettings = new AmCharts.ChartCursorSettings();
        cursorSettings.categoryBalloonEnabled = true;
        cursorSettings.categoryBalloonDateFormats = [
            {
                period: 'fff',
                format: 'JJ:NN:SS'
            },
            {
                period: 'ss',
                format: 'JJ:NN:SS'
            },
            {
                period: 'mm',
                format: 'JJ:NN DD.MM.YYYY'
            },
            {
                period: 'hh',
                format: 'JJ:NN DD.MM.YYYY'
            },
            {
                period: 'DD',
                format: 'JJ:NN DD.MM.YYYY'
            },
            {
                period: 'WW',
                format: 'DD.MM.YYYY'
            },
            {
                period: 'MM',
                format: 'DD.MM.YYYY'
            },
            {
                period: 'YYYY',
                format: 'MMMM YYYY'
            }
        ];
        cursorSettings.cursorAlpha = 0.05;
        cursorSettings.fullWidth = true;
        cursorSettings.valueBalloonsEnabled = true;
        cursorSettings.valueLineEnabled = true;
        cursorSettings.valueLineBalloonEnabled = true;
        cursorSettings.valueLineAlpha = 0.5;
        _chart.chartCursorSettings = cursorSettings;

        var categoryAxesSettings = new AmCharts.CategoryAxesSettings();
        categoryAxesSettings.groupToPeriods = ["1mm"];
        categoryAxesSettings.minPeriod = "1mm";
        categoryAxesSettings.maxSeries = 150;
        categoryAxesSettings.dateFormats = [
            {
                period: 'fff',
                format: 'JJ:NN:SS'
            },
            {
                period: 'ss',
                format: 'JJ:NN:SS'
            },
            {
                period: 'mm',
                format: 'JJ:NN'
            },
            {
                period: 'hh',
                format: 'JJ:NN'
            },
            {
                period: 'DD',
                format: 'DD.MM.'
            },
            {
                period: 'WW',
                format: 'DD.MM.'
            },
            {
                period: 'MM',
                format: 'DD.MM.'
            },
            {
                period: 'YYYY',
                format: 'MMMM YYYY'
            }
        ];
        _chart.categoryAxesSettings = categoryAxesSettings;

        var valueAxesSettings = new AmCharts.ValueAxesSettings();
        valueAxesSettings.inside = false;
        valueAxesSettings.unit = mediumUnit;
        _chart.valueAxesSettings = valueAxesSettings;

        _chart.addListener("dataUpdated", function() {
            setTimeout(zoomOut, 250);
        });

        _chart.write(container);
        loadData();
    };

    var zoomMax = function() {
        zoomOut();
        inactive();
        $("#" + container + "_zoomMax").addClass("active");
    };
    var inactive = function() {
        $("#" + container + "_zoomMax").removeClass("active");
    };
    var autoLoad = function() {
        autoLoad = !autoLoad;
        if(autoLoad) loadData();
        $("#" + container + "_autoLoad").toggleClass("disabled").css("cursor", "pointer");
    }
    /* public */
    /* contructor */
    createChart();
    $("#" + container + "_autoLoad").click(autoLoad);
    $("#" + container + "_zoomMax").click(zoomMax);
};
